import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/rooster/admin/src/app/app.component.ts